'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	type: 'TRUSTPILOT',
	name: 'Trustpilot',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*'],
	category: 'Plugins',
	props: [{
		name: 'locale',
		inputType: 'text',
		label: 'Locale',
		default: 'sv-SE'
	}, {
		name: 'templateId',
		inputType: 'text',
		label: 'Template ID',
		default: ''
	}, {
		name: 'businessUnitId',
		inputType: 'text',
		label: 'Business Unit ID',
		default: ''
	}, {
		name: 'height',
		inputType: 'text',
		label: 'Height',
		default: '100px'
	}, {
		name: 'width',
		inputType: 'text',
		label: 'Width',
		default: '100px'
	}, {
		name: 'theme',
		inputType: 'text',
		label: 'Theme',
		default: 'light'
	}, {
		name: 'stars',
		inputType: 'text',
		label: 'Stars',
		default: '1,2,3,4,5'
	}, {
		name: 'reviewLink',
		inputType: 'text',
		label: 'Review Link',
		default: ''
	}]
};